exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3p6vh0-5C64pqHjhBUJ8zc {\n    padding-top: 15px;\n    padding-bottom: 15px;\n    gap: 54px;\n    justify-content: center;\n    display: flex;\n}\n", ""]);

// exports
exports.locals = {
	"root": "_3p6vh0-5C64pqHjhBUJ8zc"
};